






import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'

@Component
export default class TimePickerFilter extends mixins(FilterComponentMixin) {
  open = false

  handleClose(): void {
    this.open = false
  }
}
